import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo, MensajeCapcha } from "../../mensajes";
import { Dimmer } from "../../spinner";
import { formatMoneda, validaMonto } from "../../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import { Input, Textarea } from "../../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";

export const ClaseVehiculos = (props) => {
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar7] = useState(false);
  const [visible, setVisible] = useState(false);
  const [activate, setActivate] = useState(false);
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const txtDescrp = useRef();
  const txtMonto = useRef();
  const txtIdc = useRef();
  const txtCodg = useRef();
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [values, setValues] = useState({
    idclasevehiculo: "",
    codigoordenanza: "",
    descripcion: "",
    monto: 0.0,
  });
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  const onChange = (event) => {
    if (
      event.target.name === "codigoordenanza" ||
      event.target.name === "descripcion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };
  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }
    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    return formatMoneda(e);
  };
  const Actualizar = (operacion) => {
    let endpoint = `${op.conexion}/api/vehiculo/createclasevehiculos/${operacion}`;
    let body;
    setActivate(true);

    body = {
      idclasevehiculo: parseInt(txtIdc.current.value),
      codigoordenanza: txtCodg.current.value.trim(),
      descripcion: txtDescrp.current.value.trim(),
      monto: txtMonto.current.value.trim().replace(/\./g, "").replace(",", "."),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let tipoope;
          if (props.operacion == 1) {
            tipoope = "INCLUIR";
          } else if (operacion == 2) {
            tipoope = "EDITAR";
          } else {
            tipoope = "ELIMINAR";
          }
          crearBitacora(
            tipoope,
            "clasevehiculo",
            response.data.clasevehiculo_act
          );
          if (props.declaWeb) {
            crearMovimientoWeb(
              props.operacion,
              "clasevehiculo",
              response.data.clasevehiculo_act
            );
          }
          props.onHideRenderizar();
          if (props.operacion === 1) {
            setTitulo("Notificacion");
            setMsg("Registro Creado Correctamente.");
            setMostrar(true);
          } else if (props.operacion === 2) {
            setTitulo("Notificacion");
            setMsg("Registro Modificado Correctamente.");
            setMostrar(true);
          } else if (props.operacion === 3) {
            setTitulo("Notificacion");
            setMsg("Registro Eliminado Correctamente.");
            setMostrar(true);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const crearBitacora = (tipoope, nomtab, idtab) => {
    let endpoint = `${op.conexion}/api/comun/crearbitacora`;
    let body;
    setActivate(true);
    body = {
      tipope: tipoope,
      nomtabla: nomtab,
      idtab: idtab,
      nanio: null,
      nmesini: 1,
      nmesfin: 12,
      fecpag: null,
      numfac: null,
      monini: 0.0,
      monaju: 0.0,
      moncrea: txtMonto.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", "."),
      idusu: JSON.parse(props.idusuario),
      fecope: fechaSistema,
      fecreal: fechaSistema,
      cdirip: JSON.parse(props.ip),
      cdirmac: JSON.parse(props.mac),
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const crearMovimientoWeb = (operacion, nomtab, idtab) => {
    let endpoint = `${op.conexion}/api/comun/crearmovimientoweb/${operacion}`;
    let body;
    setActivate(true);
    body = {
      idmovi: null,
      nomtabla: nomtab,
      idtab: idtab,
      fecmovi: fechaSistema,
      riff: null,
      idcomer: idtab,
      idact: null,
      nanio: null,
      mess: null,
      tipdecla: null,
      numfac: null,
      prefac: null,
      operaper: null,
      actu: false,
      nmes: null,
      tip: null,
      peri: null,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtCodg.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("Debe introducir el Codigo de la Clase del Vehiculo");
      sigue = false;
      setTabIndex(0);
      txtCodg.current.focus();
      setMostrar(true);
    } else if (txtDescrp.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("Debe Introducir la Descripción de la Clase");
      sigue = false;
      txtDescrp.current.focus();
      setMostrar(true);
    } else if (txtMonto.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("El Monto no debe ir vacio");
      sigue = false;
      txtMonto.current.focus();
      setMostrar(true);
    } else if (sigue === true) {
      Actualizar(props.operacion);
    }
  };

  const blanquear = () => {
    setVisible(false);
    setMostrar1(false);
    setActivate(false);
    setValues({
      idclasevehiculo: "",
      codigoordenanza: "",
      descripcion: "",
      monto: 0.0,
    });
    setTabIndex(0);
    setOperacion(0);
    setMsg("");
  };

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = (e) => {
    e.preventDefault();
    setMostrar(false);
    if (
      msg == "Registro Creado Correctamente." ||
      msg == "Registro Modificado Correctamente." ||
      msg == "Registro Eliminado Correctamente."
    ) {
      blanquear();
      props.onHideCancela();
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setVisible(false);
        btnAcepta.current.focus();
        setOperacion(props.operacion);
        setTabIndex(0);
        if (props.operacion !== 1) {
          setValues(props.clasevehiculo);
        }
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light">
        <h3 className="fw-bold m-0">
          {props.operacion === 1
            ? "Agregar Clase Vehiculos."
            : props.operacion === 2
            ? "Editar Clase Vehiculos."
            : props.operacion === 3
            ? "Eliminar Clase Vehiculos."
            : "Consultar Clase Vehiculos."}
        </h3>
        <a type = "button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
            <legend className="float-none w-auto m-0">
                Clasificador de Vehiculos Según Ordenanza
            </legend>
            <div className="col-2 m-0 mb-2 p-0">
                <Input label = 'Código:'
                    disabled={true}
                    ref={txtIdc}
                    name="idclasevehiculo"
                    value={values.idclasevehiculo}
                    id="inputCodigo"
                />
            </div>
            <div className="col-5 m-0 mb-2 p-0 pl-2">
                <Input label = 'Codigo Según Ordenanza:'
                    disabled={
                    operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    ref={txtCodg}
                    name="codigoordenanza"
                    onChange={onChange}
                    defaultValue={values.codigoordenanza.trim()}
                    id="inputRitm"
                />
            </div>
            <div className="col-5 m-0 mb-2 p-0 pl-2">
                <Input label = 'Monto de la Unidad:'
                    disabled={
                    operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    ref={txtMonto}
                    name="monto"
                    defaultValue={
                    values && values.monto
                        ? formatMoneda(
                            values.monto.replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2
                        )
                        ? formatMoneda(
                            values.monto.replace(",", "").replace(".", ","),
                            ",",
                            ".",
                            2
                            )
                        : ""
                        : ""
                    }
                    onKeyUp={handleInputMontoChange}
                    onBlur={handleInputMontoChange}
                    id="inputMonto"
                    inputClassName='text-end'
                />
            </div>
            <div className="col-12 m-0 p-0">
                <Textarea label = 'Descripción:'
                    style={{ height: 70 }}
                    disabled={
                    operacion === 4 || operacion === 3
                        ? true
                        : deshabilitado
                    }
                    ref={txtDescrp}
                    name="descripcion"
                    onChange={onChange}
                    defaultValue={values.descripcion.trim()}
                    id="inputDescripcion"
                />
            </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          ref={btnAcepta}
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
        >
            Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <MensajeSiNo
          titulo={titulo}
          mensaje={msg}
          show={mostrar1}
          onHideSi={handleCloseSi}
          onHideNo={handleCloseNo}
        />
        <MensajeCapcha show={mostrar7} onHideAcepta={""} onHideCancela={""} />
        <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
